// extracted by mini-css-extract-plugin
export var baseButton = "_or-0";
export var controlsArrowKeys = "_or-1";
export var controlsResetButton = "_or-2";
export var lightGameButton = "_or-4 _or-0";
export var playAgainButton = "_or-5 _or-0";
export var startGameButton = "_or-3 _or-0";